import { render, staticRenderFns } from "./ProfileDpe.vue?vue&type=template&id=28b5db10&scoped=true"
import script from "./ProfileDpe.vue?vue&type=script&lang=js"
export * from "./ProfileDpe.vue?vue&type=script&lang=js"
import style0 from "./ProfileDpe.vue?vue&type=style&index=0&id=28b5db10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b5db10",
  null
  
)

export default component.exports